<template>
	<div :class="['home', user ? 'logged-in' : '']">	
		<shelf v-if="user"></shelf>	
		<intro :active-category="activeCategory" :active-root-category="activeRootCategory" :categories="activeCategories"></intro>
		<!-- <cat-strip></cat-strip> -->
	</div>
</template>
<script>

import Intro from '../partials/Intro.vue';
// import CatStrip from '../partials/CatStrip.vue';
import { mapState, mapGetters, mapActions } from 'vuex';
export default {
	watch: {
		$route (to, from){
			window.scrollTo(0, 0);
		}
	},
	created() {
		
	},
	data() {
		return {
			images:['/img/backgrounds/background-1.jpg']
		}
	},
	components: {
		Intro,
		'shelf': () => import('../partials/Shelf.vue')
		// CatStrip
	},
	mounted() {
		this.searchFilterString('');

	},
	beforeRouteLeave (to, from, next) {
		this.hideOverlay()
		next()
  	},
	computed: {
		...mapState([
			'user',
		]),
		...mapGetters([
			'activeCategory',
			'activeRootCategory',
			'activeCategories'
		])
		
	},
	methods: {
		...mapActions([
			'hideOverlay',
			'searchFilterString'
		])
	},
}
</script>

<style lang="stylus">
.home
	width 100%
	height 100%
	overflow hidden
	transition height 0.3s ease-out
	&.logged-in
		height calc(100% - 240px)		
</style>

<style>
	.home .shelf-wrap 
	{
		margin-top: 0px;
	}
	@media screen and (max-width:815px) {
		.home.logged-in {
			height: auto;
			//overflow-y: scroll;
		}
	}
</style>

